module.exports = __webpack_public_path__ + "img/P2-A5.37e23f80.svg";